import { render } from "./FlasksIcon.vue?vue&type=template&id=4cc22414"
import script from "./FlasksIcon.vue?vue&type=script&lang=js"
export * from "./FlasksIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__